import { environment } from "src/environments/environment"
import { BillingAddress } from "./BillingAddress.interface"

export const INITIAL_BILLING_ADDRESS: BillingAddress = (environment.mock && environment.mockBillingAddress) ?  {
  inherit: false,
  title: "Herr",
  firstName: "Owi-Wan",
  lastName: "Kenobi",
  streetName: "Wallerfanger Str.",
  streetNumber: "23",
  postalCode: "66740",
  city: "Saarlouis"
} : {
  inherit: true,
  title: "",
  firstName: "",
  lastName: "",
  streetName: "",
  streetNumber: "",
  postalCode: "",
  city: ""
}
